import WSReader from "../rocket/WSReader";
import MessageDispatch from "../rocket/MessageDispatch";
import { RPCConstants } from "../rocket/D3ETemplate";

export default class StudioServiceClient {
  public async postLog(action: string, desc: string): Promise<string> {
    let r: WSReader = await MessageDispatch.get().rpcMessage(
      RPCConstants.StudioService,
      RPCConstants.StudioServicePostLog,
      {
        "args": (w) => {
          w.writeString(action);

          w.writeString(desc);
        },
      }
    );

    let code: number = r.readByte();

    if (code === 1) {
      let error: string = r.readString();

      return Promise.error(error);
    }

    return r.readString() as string;
  }
}
